<template>
  <mdb-container class="gp-has-header">
    <div v-if="showMain" class="text-left">
      <mdb-btn icon="plus-circle" @click="newAnnouncement">New</mdb-btn>
      <data-table :clickHandler="openAnnouncement"
                  :columns="columns"
                  dataSource="/admin/announcement"
                  pageTitle="Announcements"/>
    </div>
    <div v-if="showAnnouncement" class="text-left">
      <mdb-btn icon="arrow-left" size="sm" @click="cancelShow">Back to List</mdb-btn>
      <mdb-card>
        <mdb-card-body>
          <mdb-input disabled label="ID" type="text" v-model="currentAnnouncement.id"/>
          <mdb-input disabled label="Date" type="text" v-model="currentAnnouncement.created"/>
          <mdb-input label="Title" type="text" v-model="currentAnnouncement.title"/>
          <div class="md-form text-left mb-4">
            <gp-select :dataObj="currentAnnouncement" :possible-values="validAudiences" :required="true" label="Audience"
                       propertyName="audience"/>
            <gp-select :dataObj="currentAnnouncement" :possible-values="validFunctions"
                       v-if="currentAnnouncement.audience == 'Function'"
                       :required="true" label="Function"
                       propertyName="functionName"/>
            <mdb-input label="Text" type="text" v-model="currentAnnouncement.text"/>
            <mdb-input label="Link" type="text" v-model="currentAnnouncement.link"/>
            <mdb-input v-if="currentAnnouncement.link" label="Link Text" type="text" v-model="currentAnnouncement.linkText"/>
            <mdb-input id="may-dismiss" label="User May Dismiss" type="checkbox" v-model="currentAnnouncement.mayDismiss"/>
            <mdb-input id="show-alert" label="Show Alert" type="checkbox" v-model="currentAnnouncement.systemTop"/>
          </div>
          <div>
            <mdb-btn @click="saveAnnouncement" icon="save" color="success">Save</mdb-btn>
            <mdb-btn v-if="currentAnnouncement.id" @click="showDeleteModal=true" icon="trash" color="danger">Delete</mdb-btn>
          </div>

        </mdb-card-body>
      </mdb-card>
    </div>

    <yes-no-modal v-if="showDeleteModal" @yes="deleteAnnouncement" @no="showDeleteModal=false"></yes-no-modal>


  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
//import {mapState} from 'vuex'
import {mdbBtn, mdbCard, mdbCardBody, mdbContainer, mdbIcon, mdbInput} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import gpSelect from "../common/GPSelect";
import YesNoModal from "../common/YesNoModal";

export default {
    name: 'admin-announcement',
    components: {
      mdbContainer, mdbBtn,
      mdbCard,
      mdbCardBody,
      mdbInput,
      mdbIcon,
      dataTable,
      gpSelect,
      YesNoModal
    },
    data() {
      return {
        rows: [],
        showDeleteModal: false,
        columns: [
          {label: "ID", field: "id"},
          {label: "Title", field: "title"},
          {label: "Audience", field: "audience"},
          {label: "Show Alert", field: "systemTop"}
        ],
        currentAnnouncement: null,
        showAnnouncement: false,
        showMain: true,
        validAudiences: [
          {text: "Group Owners", value: "Group Owners"},
          {text: "Group Admins", value: "Group Admins"},
          {text: "Organizers", value: "Organizers"},
          {text: "Existing Users", value: "Existing Users"},
          {text: "New Users", value: "New Users"},
          {text: "All Users", value: "All Users"},
          {text: "Backend Function", value: "Function"}
        ],
        validFunctions: [
          {text: "Balance Due", value: "balanceDue"}

        ]
      }
    },
    computed:  {
      settings() {
        return this.$store.state.settings
      }
    },
    mounted() {
      if (this.$route.params.action == "proxy") this.proxy()
      if (this.settings.siteName == 'Ezumee') {
        this.validFunctions.push({text: "Ezumee - Trial Period Notice", value: "ezumeeTrialPeriod"})
        this.validFunctions.push({text: "Ezumee - Billing Suspension", value: "ezumeeBillingSuspension"})
      }
    },
    methods: {
      deleteAnnouncement: function() {
        this.showDeleteModal = false
        this.$store.dispatch("setExecuting", true)
        api.delete("/admin/announcement/" + this.currentAnnouncement.id).then(
          (results) => {
            this.showAnnouncement = false
            this.showMain = true
            let loc = this.rows.indexOf(this.currentAnnouncement)
            this.rows.splice(loc,1)
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      newAnnouncement: function () {
        this.currentAnnouncement = {
          id: null,
          created: null,
          systemTop: true,
          audience: "All Users",
          link: "",
          text: "",
          linkText: "",
          mayDismiss: false
        }
        this.showMain = false
        this.showAnnouncement = true
      },
      saveAnnouncement: function() {
        this.$store.dispatch("setExecuting", true)
        api.post("/admin/announcement", this.currentAnnouncement).then(
          (results) => {
            this.$store.dispatch("setDataTableReload")
            this.showAnnouncement = false
            this.showMain = true
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      },
      cancelShow: function () {
        this.showMain = true
        this.currentAnnouncement = null
        this.showAnnouncement = false
      },
      openAnnouncement: function (row) {
        this.showMain = false
        this.currentAnnouncement = row
        this.showAnnouncement = true
      }

    }

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
